// import React, { useEffect, useState } from "react";
// import {
//   Row, Col, Button, notification, Form, Input, Select, DatePicker, Space
// } from "antd";
// import axios from "axios";
// import { UserOutlined, PhoneOutlined, MailOutlined, BankOutlined, CheckCircleOutlined } from '@ant-design/icons';
// import moment from 'moment';
// import { baseUrl } from "../../config";

// const { Option } = Select;
// const { TextArea } = Input;

// function BeneficiariesForm({ beneficiaryId, onRefreshData = () => {} }) {
//   const [form] = Form.useForm();
//   const [isUpdateMode, setIsUpdateMode] = useState(false);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (beneficiaryId) {
//       setIsUpdateMode(true);
//       fetchBeneficiaryDetails();
//     }
//   }, [beneficiaryId]);

//   const fetchBeneficiaryDetails = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseUrl}/beneficiaries/read/${beneficiaryId}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//         },
//       });
      
//       if (response.status === 200) {
//         const data = response.data.result;
//         form.setFieldsValue({
//           ...data,
//           dob: data.dob ? moment(data.dob) : null,
//           registration_date: data.registration_date ? moment(data.registration_date) : null
//         });
//       }
//     } catch (error) {
//       notification.error({
//         message: 'Error',
//         description: 'Failed to fetch beneficiary details',
//         placement: 'topRight'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const onFinish = async (values) => {
//     try {
//       setLoading(true);
      
//       const formData = {
//         ...values,
//         dob: values.dob ? values.dob.format('YYYY-MM-DD') : null,
//         registration_date: values.registration_date ? values.registration_date.format('YYYY-MM-DD') : null
//       };

//       let response;
//       if (isUpdateMode) {
//         response = await axios.patch(`${baseUrl}/beneficiaries/update/${beneficiaryId}`, formData, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//           },
//         });
//       } else {
//         response = await axios.post(`${baseUrl}/beneficiaries/create`, formData, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//           },
//         });
//       }

//       if (response.status === 200) {
//         notification.success({
//           message: 'Success',
//           description: isUpdateMode ? 'Beneficiary updated successfully!' : 'Beneficiary created successfully!',
//           placement: 'topRight'
//         });
        
//         onRefreshData();
        
//         if (!isUpdateMode) {
//           form.resetFields();
//         }
//       }
//     } catch (error) {
//       notification.error({
//         message: 'Error',
//         description: error.response?.data?.message || 'Operation failed',
//         placement: 'topRight'
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ padding: '20px' }}>
//       <Form 
//         form={form} 
//         onFinish={onFinish} 
//         layout="vertical"
//         requiredMark={false}
//       >
//         <Row gutter={[16, 16]}>
//           <Col xs={24} sm={12}>
//             <Form.Item
//               label="Name"
//               name="name"
//               rules={[{ required: true, message: 'Please enter name' }]}
//             >
//               <Input
//                 prefix={<UserOutlined />}
//                 placeholder="Enter full name"
//                 size="large"
//               />
//             </Form.Item>
//           </Col>
          
//           <Col xs={24} sm={12}>
//             <Form.Item
//               label="Type"
//               name="type"
//               rules={[{ required: true, message: 'Please select type' }]}
//             >
//               <Select placeholder="Select beneficiary type" size="large">
//                 <Option value="Student">Student</Option>
//                 <Option value="Staff">Staff</Option>
//                 <Option value="Vendor">Vendor</Option>
//                 <Option value="Gurukul">Gurukul</Option>
//                 <Option value="Partner_Organization">Partner Organization</Option>
//                 <Option value="Government">Government</Option>
//                 <Option value="Other">Other</Option>
//               </Select>
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item
//               label="Phone"
//               name="phone"
//               rules={[
//                 { required: true, message: 'Please enter phone number' },
//                 { pattern: /^\d{10,12}$/, message: 'Phone must be 10-12 digits!' }
//               ]}
//             >
//               <Input
//                 prefix={<PhoneOutlined />}
//                 placeholder="Enter phone number"
//                 size="large"
//                 maxLength={12}
//               />
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item
//               label="Email"
//               name="email"
//               rules={[
//                 { type: 'email', message: 'Please enter valid email!' }
//               ]}
//             >
//               <Input
//                 prefix={<MailOutlined />}
//                 placeholder="Enter email address"
//                 size="large"
//               />
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item label="Gender" name="gender">
//               <Select placeholder="Select gender" size="large">
//                 <Option value="Male">Male</Option>
//                 <Option value="Female">Female</Option>
//                 <Option value="Other">Other</Option>
//               </Select>
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item label="Date of Birth" name="dob">
//               <DatePicker
//                 format="DD-MM-YYYY"
//                 placeholder="Select date of birth"
//                 size="large"
//                 style={{ width: '100%' }}
//               />
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item label="City" name="city">
//               <Input placeholder="Enter city" size="large" />
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item label="State" name="state">
//               <Input placeholder="Enter state" size="large" />
//             </Form.Item>
//           </Col>

//           <Col span={24}>
//             <Form.Item label="Address" name="address">
//               <TextArea placeholder="Enter complete address" rows={3} />
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item label="Bank Name" name="bank_name">
//               <Input
//                 prefix={<BankOutlined />}
//                 placeholder="Enter bank name"
//                 size="large"
//               />
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item label="Account Number" name="bank_account_no">
//               <Input placeholder="Enter account number" size="large" />
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item label="IFSC Code" name="ifsc_code">
//               <Input placeholder="Enter IFSC code" size="large" />
//             </Form.Item>
//           </Col>

//           <Col xs={24} sm={12}>
//             <Form.Item label="Status" name="status">
//               <Select placeholder="Select status" size="large" defaultValue="Active">
//                 <Option value="Active">Active</Option>
//                 <Option value="Inactive">Inactive</Option>
//                 <Option value="Suspended">Suspended</Option>
//               </Select>
//             </Form.Item>
//           </Col>
//         </Row>

//         <div style={{ textAlign: 'center', marginTop: '30px' }}>
//           <Button
//             type="primary"
//             htmlType="submit"
//             size="large"
//             loading={loading}
//             icon={<CheckCircleOutlined />}
//             style={{
//               borderRadius: '8px',
//               minWidth: '200px',
//               height: '50px',
//               fontSize: '16px'
//             }}
//           >
//             {isUpdateMode ? 'Update Beneficiary' : 'Create Beneficiary'}
//           </Button>
//         </div>
//       </Form>
//     </div>
//   );
// }

// export default BeneficiariesForm;



import React, { useEffect, useState } from "react";
import {
  Row, Col, Button, notification, Form, Input, Select, DatePicker, Divider,
  Modal, List, Popconfirm, Typography, Upload, Spin, Card, Avatar, Tooltip,
} from "antd";
import axios from "axios";
import { UserOutlined, PhoneOutlined, MailOutlined, BankOutlined, SaveOutlined, SettingOutlined, PlusOutlined, DeleteOutlined, UploadOutlined, EyeOutlined, IdcardOutlined, FileProtectOutlined } from '@ant-design/icons';
import moment from 'moment';
import { baseUrl } from "../../config";

const sectionLabel = (title) => (
  <Divider orientation="left" style={{ color: '#7a0000', fontWeight: 700, fontSize: 13, borderColor: '#d0dce8', margin: '16px 0 8px' }}>
    {title}
  </Divider>
);

const { Option } = Select;
const { TextArea } = Input;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('accessToken')}` });

function BeneficiariesForm({ beneficiaryId, onRefreshData = () => {} }) {
  const [form] = Form.useForm();
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [loading, setLoading] = useState(false);
  // Tracks the actual ID (from props for edit, or returned by API after create)
  const [currentId, setCurrentId] = useState(beneficiaryId || null);

  // Document uploads
  const [docUrls, setDocUrls] = useState({
    photo_url: null, aadhar_doc_url: null, pan_doc_url: null,
    bank_doc_url: null, gst_doc_url: null,
  });
  const [docUploading, setDocUploading] = useState({});

  // Configurable types
  const [types, setTypes]               = useState([]);
  const [typesModalOpen, setTypesModalOpen] = useState(false);
  const [newTypeName, setNewTypeName]   = useState('');
  const [addingType, setAddingType]     = useState(false);

  useEffect(() => { loadTypes(); }, []); // eslint-disable-line

  const loadTypes = async () => {
    try {
      const res = await axios.get(`${baseUrl}/beneficiary-types/list`, { headers: authHeaders() });
      if (res.data.status) setTypes(res.data.result);
    } catch { /* fail silently — types still usable if already set */ }
  };

  const handleDocUpload = async (docType, file) => {
    setDocUploading(prev => ({ ...prev, [docType]: true }));
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('docType', docType);
      const res = await axios.post(
        `${baseUrl}/beneficiaries/upload-document/${currentId}`,
        fd,
        { headers: { ...authHeaders() } }
      );
      if (res.data.status) {
        const colMap = { photo: 'photo_url', aadhar: 'aadhar_doc_url', pan: 'pan_doc_url', bank: 'bank_doc_url', gst: 'gst_doc_url' };
        setDocUrls(prev => ({ ...prev, [colMap[docType]]: res.data.file_url }));
        notification.success({ message: 'Document uploaded' });
      }
    } catch (err) {
      notification.error({ message: 'Upload failed', description: err.response?.data?.message || err.message });
    } finally {
      setDocUploading(prev => ({ ...prev, [docType]: false }));
    }
  };

  const handleDocDelete = async (docType) => {
    const colMap = { photo: 'photo_url', aadhar: 'aadhar_doc_url', pan: 'pan_doc_url', bank: 'bank_doc_url', gst: 'gst_doc_url' };
    try {
      await axios.delete(`${baseUrl}/beneficiaries/delete-document/${currentId}/${docType}`, { headers: authHeaders() });
      setDocUrls(prev => ({ ...prev, [colMap[docType]]: null }));
      notification.success({ message: 'Document removed' });
    } catch {
      notification.error({ message: 'Failed to remove document' });
    }
  };

  const handleAddType = async () => {
    if (!newTypeName.trim()) return;
    setAddingType(true);
    try {
      await axios.post(`${baseUrl}/beneficiary-types/create`, { name: newTypeName.trim() }, { headers: authHeaders() });
      setNewTypeName('');
      await loadTypes();
      notification.success({ message: 'Type added' });
    } catch (err) {
      notification.error({ message: err.response?.data?.message || 'Failed to add type' });
    } finally {
      setAddingType(false);
    }
  };

  const handleDeleteType = async (id) => {
    try {
      await axios.delete(`${baseUrl}/beneficiary-types/delete/${id}`, { headers: authHeaders() });
      await loadTypes();
      notification.success({ message: 'Type removed' });
    } catch {
      notification.error({ message: 'Failed to remove type' });
    }
  };

  useEffect(() => {
    if (beneficiaryId) {
      setIsUpdateMode(true);
      fetchBeneficiaryDetails();
    }
  }, [beneficiaryId]);

  const fetchBeneficiaryDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${baseUrl}/beneficiaries/read/${beneficiaryId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      
      if (response.status === 200) {
        const data = response.data.result;
        form.setFieldsValue({
          ...data,
          dob: data.dob ? moment(data.dob) : null,
          registration_date: data.registration_date ? moment(data.registration_date) : null,
        });
        setDocUrls({
          photo_url:      data.photo_url      || null,
          aadhar_doc_url: data.aadhar_doc_url || null,
          pan_doc_url:    data.pan_doc_url    || null,
          bank_doc_url:   data.bank_doc_url   || null,
          gst_doc_url:    data.gst_doc_url    || null,
        });
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Failed to fetch beneficiary details',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      
      const formData = {
        ...values,
        dob: values.dob ? values.dob.format('YYYY-MM-DD') : null,
        registration_date: values.registration_date ? values.registration_date.format('YYYY-MM-DD') : null
      };

      let response;
      if (isUpdateMode) {
        response = await axios.patch(`${baseUrl}/beneficiaries/update/${beneficiaryId}`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      } else {
        response = await axios.post(`${baseUrl}/beneficiaries/create`, formData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        });
      }

      if (response.status === 200) {
        if (!isUpdateMode) {
          // After create: switch to update mode so documents section appears
          const newId = response.data?.data?.id || response.data?.id;
          if (newId) {
            setCurrentId(newId);
            setIsUpdateMode(true);
          }
          notification.success({
            message: 'Beneficiary Created!',
            description: 'Beneficiary saved. You can now upload documents below.',
            placement: 'topRight'
          });
        } else {
          notification.success({
            message: 'Success',
            description: 'Beneficiary updated successfully!',
            placement: 'topRight'
          });
        }
        onRefreshData();
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error.response?.data?.message || 'Operation failed',
        placement: 'topRight'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '4px 0 24px' }}>
      <Form form={form} onFinish={onFinish} layout="vertical" requiredMark={false} size="middle">

        {sectionLabel('Basic Information')}
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={8}>
            <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please enter name' }]}>
              <Input prefix={<UserOutlined />} placeholder="Full name" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              label={
                <span>
                  Type&nbsp;
                  <Button
                    type="link"
                    size="small"
                    icon={<SettingOutlined />}
                    style={{ fontSize: 11, padding: 0, height: 'auto' }}
                    onClick={() => setTypesModalOpen(true)}
                  >
                    Manage
                  </Button>
                </span>
              }
              name="type"
              rules={[{ required: true, message: 'Please select type' }]}
            >
              <Select placeholder="Select type" showSearch optionFilterProp="children">
                {types.map(t => <Option key={t.id} value={t.name}>{t.name}</Option>)}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Gender — बालक/बालिका" name="gender">
              <Select placeholder="Select gender">
                <Option value="Male">बालक (Male)</Option>
                <Option value="Female">बालिका (Female)</Option>
                <Option value="Other">Other</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Family Status — पारिवारिक स्थिति" name="family_status">
              <Select placeholder="Select family status" allowClear showSearch optionFilterProp="children">
                <Option value="आर्थिक स्थिति कमजोर">आर्थिक स्थिति कमजोर</Option>
                <Option value="पिता का देहांत">पिता का देहांत</Option>
                <Option value="माता का देहांत">माता का देहांत</Option>
                <Option value="पिता का देहांत, आर्थिक स्थिति कमजोर">पिता का देहांत, आर्थिक स्थिति कमजोर</Option>
                <Option value="माता का देहांत, आर्थिक स्थिति कमजोर">माता का देहांत, आर्थिक स्थिति कमजोर</Option>
                <Option value="पिता का देहांत, माता का देहांत">पिता का देहांत, माता का देहांत</Option>
                <Option value="पिता दिव्यांग">पिता दिव्यांग</Option>
                <Option value="विद्यार्थी दिव्यांग">विद्यार्थी दिव्यांग</Option>
                <Option value="उल्लेख नहीं">उल्लेख नहीं</Option>
                <Option value="अन्य">अन्य</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Date of Birth" name="dob">
              <DatePicker format="DD-MM-YYYY" placeholder="Select DOB" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Father's Name" name="father_name">
              <Input placeholder="Father's name" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Status" name="status" initialValue="Active">
              <Select>
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
                <Option value="Suspended">Suspended</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Registration Date" name="registration_date">
              <DatePicker format="DD-MM-YYYY" style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>

        {sectionLabel('Contact & Address')}
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={8}>
            <Form.Item label="Phone" name="phone"
              rules={[{ required: true, message: 'Required' }, { pattern: /^\d{10,12}$/, message: '10-12 digits' }]}>
              <Input prefix={<PhoneOutlined />} placeholder="Phone number" maxLength={12} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Email" name="email" rules={[{ type: 'email', message: 'Invalid email' }]}>
              <Input prefix={<MailOutlined />} placeholder="Email address" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="City" name="city"><Input placeholder="City" /></Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="State" name="state"><Input placeholder="State" /></Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Pincode" name="pincode"><Input placeholder="Pincode" /></Form.Item>
          </Col>
          <Col xs={24} sm={16}>
            <Form.Item label="Address" name="address">
              <TextArea placeholder="Full address" rows={2} />
            </Form.Item>
          </Col>
        </Row>

        {sectionLabel('Bank Details')}
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={8}>
            <Form.Item label="Bank Name" name="bank_name">
              <Input prefix={<BankOutlined />} placeholder="Bank name" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Account Number" name="bank_account_no">
              <Input placeholder="Account number" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="IFSC Code" name="ifsc_code">
              <Input placeholder="IFSC code" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="Branch Name" name="branch_name">
              <Input placeholder="Branch name" />
            </Form.Item>
          </Col>
        </Row>

        {sectionLabel('Identity Documents')}
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={8}>
            <Form.Item label="Aadhar Number" name="aadhar_no">
              <Input placeholder="Aadhar number" maxLength={12} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="PAN Number" name="pan_no">
              <Input placeholder="PAN number" maxLength={10} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item label="GST Number" name="gst_no">
              <Input placeholder="GST number" />
            </Form.Item>
          </Col>
        </Row>

        {/* Documents — shown after create or when editing */}
        {currentId && (() => {
          const docs = [
            { key: 'photo',  colKey: 'photo_url',      label: 'Profile Photo',       icon: <UserOutlined />,        accept: 'image/*',       isImage: true },
            { key: 'aadhar', colKey: 'aadhar_doc_url', label: 'Aadhar Card',          icon: <IdcardOutlined />,      accept: 'image/*,.pdf',  isImage: false },
            { key: 'pan',    colKey: 'pan_doc_url',    label: 'PAN Card',             icon: <IdcardOutlined />,      accept: 'image/*,.pdf',  isImage: false },
            { key: 'bank',   colKey: 'bank_doc_url',   label: 'Bank Passbook / Cheque', icon: <BankOutlined />,     accept: 'image/*,.pdf',  isImage: false },
            { key: 'gst',    colKey: 'gst_doc_url',    label: 'GST Certificate',      icon: <FileProtectOutlined />, accept: 'image/*,.pdf',  isImage: false },
          ];
          return (
            <>
              {sectionLabel('Documents')}
              <Row gutter={[12, 12]}>
                {docs.map(doc => {
                  const url      = docUrls[doc.colKey];
                  const isPdf    = url && url.toLowerCase().endsWith('.pdf');
                  const uploading = docUploading[doc.key];
                  return (
                    <Col key={doc.key} xs={24} sm={12} md={8}>
                      <Card
                        size="small"
                        style={{ border: '1px dashed #d0d0d0', borderRadius: 8, textAlign: 'center', background: '#fafafa' }}
                        bodyStyle={{ padding: '14px 10px' }}
                      >
                        {url && doc.isImage ? (
                          <Avatar src={url} size={64} style={{ marginBottom: 8, display: 'block', margin: '0 auto 8px' }} />
                        ) : url ? (
                          <div style={{ marginBottom: 8 }}>
                            {isPdf
                              ? <FileProtectOutlined style={{ fontSize: 36, color: '#ff4d4f' }} />
                              : <IdcardOutlined style={{ fontSize: 36, color: '#1890ff' }} />
                            }
                          </div>
                        ) : (
                          <div style={{ fontSize: 28, color: '#ccc', marginBottom: 8 }}>{doc.icon}</div>
                        )}

                        <div style={{ fontWeight: 600, fontSize: 12, marginBottom: 8, color: '#333' }}>{doc.label}</div>

                        {url ? (
                          <div style={{ display: 'flex', gap: 4, justifyContent: 'center', flexWrap: 'wrap' }}>
                            <Tooltip title="View / Download">
                              <Button size="small" icon={<EyeOutlined />} onClick={() => window.open(url, '_blank')} />
                            </Tooltip>
                            <Upload
                              showUploadList={false}
                              accept={doc.accept}
                              beforeUpload={file => { handleDocUpload(doc.key, file); return false; }}
                            >
                              <Tooltip title="Replace">
                                <Button size="small" icon={<UploadOutlined />} loading={uploading} />
                              </Tooltip>
                            </Upload>
                            <Popconfirm
                              title="Remove this document?"
                              onConfirm={() => handleDocDelete(doc.key)}
                              okText="Remove" okButtonProps={{ danger: true }}
                            >
                              <Button size="small" danger icon={<DeleteOutlined />} />
                            </Popconfirm>
                          </div>
                        ) : (
                          <Upload
                            showUploadList={false}
                            accept={doc.accept}
                            beforeUpload={file => { handleDocUpload(doc.key, file); return false; }}
                          >
                            <Button
                              size="small"
                              icon={uploading ? <Spin size="small" /> : <UploadOutlined />}
                              loading={uploading}
                              style={{ width: '100%' }}
                            >
                              Upload
                            </Button>
                          </Upload>
                        )}
                      </Card>
                    </Col>
                  );
                })}
              </Row>
            </>
          );
        })()}

        <div style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'flex-end' }}>
          <Button htmlType="submit" loading={loading} icon={<SaveOutlined />} size="large"
            style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff', minWidth: 180 }}>
            {isUpdateMode ? 'Update Beneficiary' : 'Save Beneficiary'}
          </Button>
        </div>
      </Form>

      {/* ── Manage Beneficiary Types Modal ── */}
      <Modal
        title={<span><SettingOutlined style={{ marginRight: 8 }} />Manage Beneficiary Types</span>}
        open={typesModalOpen}
        onCancel={() => setTypesModalOpen(false)}
        footer={null}
        width={400}
        destroyOnClose
      >
        <div style={{ marginBottom: 16 }}>
          <Input.Group compact>
            <Input
              style={{ width: 'calc(100% - 80px)' }}
              placeholder="New type name..."
              value={newTypeName}
              onChange={e => setNewTypeName(e.target.value)}
              onPressEnter={handleAddType}
            />
            <Button
              type="primary"
              icon={<PlusOutlined />}
              loading={addingType}
              onClick={handleAddType}
              style={{ background: '#7a0000', borderColor: '#7a0000', width: 80 }}
            >
              Add
            </Button>
          </Input.Group>
        </div>
        <List
          size="small"
          bordered
          dataSource={types}
          locale={{ emptyText: 'No types yet' }}
          renderItem={item => (
            <List.Item
              actions={[
                <Popconfirm
                  title={`Remove "${item.name}"?`}
                  onConfirm={() => handleDeleteType(item.id)}
                  okText="Remove"
                  okButtonProps={{ danger: true }}
                >
                  <Button danger size="small" icon={<DeleteOutlined />} />
                </Popconfirm>
              ]}
            >
              <Typography.Text>{item.name}</Typography.Text>
            </List.Item>
          )}
        />
      </Modal>
    </div>
  );
}

export default BeneficiariesForm;